import api from '@/helpers/api.js';

export default {
  initialize: () => api.get('/Session/Initialize'),

  setLanguage: (languageKey) => {
    api.post('/Session/SetLanguage/' + languageKey);
  }
};
